import { render } from "./FooterCopyright.vue?vue&type=template&id=4347895d&scoped=true&ts=true"
import script from "./FooterCopyright.vue?vue&type=script&lang=ts"
export * from "./FooterCopyright.vue?vue&type=script&lang=ts"

import "./FooterCopyright.vue?vue&type=style&index=0&id=4347895d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4347895d"]])

export default __exports__